import { createAsyncThunk } from '@reduxjs/toolkit';
import axios from "axios";
import logoutAndRedirect from "../../utils/logoutAndRedirect";
import { getAccessToken } from "../../utils/tokenStore";

const URL_API = process.env.URL_API;

export interface ScheduleResult {
    data: any[];
}

export const updateSchedule = createAsyncThunk(
    'calendar/update',
    async (params: any, { rejectWithValue }) => {
        const { jobId, eventId, ...rest} = params;
        const updateURL = `${URL_API}/supplier-portal/calendar/events/${eventId}`;
        

        try {
            const { data } = await axios.put<ScheduleResult>(updateURL, rest, {
                headers: {
                    'Authorization': `Bearer ${getAccessToken()}`
                }
            });

            return data;

        } catch (error) {
            // @ts-ignore
            if (error.response?.status === 401) {
                logoutAndRedirect('/sign-in')
            }

            // @ts-ignore
            return rejectWithValue(error.response?.data ?? error)
        }
    }
);
